/* @flow */

import type { $BaseWidgetState } from '../types/BaseWidgetState';
import type { $WidgetField } from '../types/WidgetField';
import { getDeepPropertyValue, getConfigurationMarketProperty } from './WidgetUtils';
import { getConfigurationTranslationValue } from './WidgetUtils';
import { getConfigurationPropertyValue } from './WidgetUtils';
import Globals from '../constants/Globals';
import { TemplateMarketPropertyKeys } from '../templates/TemplateMarketProperties';

export const getWidgetFieldValue = (field: $WidgetField, widgetState: $BaseWidgetState): ?string => {
  const isDealerDataField = field.fkey.indexOf(`${Globals.WIDGET_FIELD_DEALER_PREFIX}.`) === 0;
  if (widgetState.dealer && isDealerDataField) {
    const keys: Array<string> = field.fkey.split('.');
    return getDeepPropertyValue(keys.slice(1), widgetState.dealer);
  }
  else if (!isDealerDataField && !field.translatable && widgetState.configuration) {
    return getConfigurationPropertyValue(widgetState.configuration, field.fkey);
  }
  else if (!isDealerDataField && field.translatable && widgetState.translations) {
    return getConfigurationTranslationValue(widgetState.translations, field.fkey);
  }
  else return null;
};

export const getVisibleWidgetFieldValueByKey = (key: string, widgetState: $BaseWidgetState): ?string => {
  const widgetFieldValue = getWidgetFieldValueByKey(key, widgetState);
  return widgetFieldValue ? (showWidgetField(widgetState.settings, key) ? widgetFieldValue : null) : null;
};

export const getWidgetFieldByKey = (widgetFields: Array<$WidgetField>, key: string): ?$WidgetField => {
  return widgetFields && widgetFields.find((field: $WidgetField) => field.fkey === key) || null;
}

export const getWidgetFieldValueByKey = (key: string, widgetState: $BaseWidgetState): ?string => {
  const field = getWidgetFieldByKey(widgetState.widgetFields, key);
  return field && getWidgetFieldValue(field, widgetState);
};

export const showWidgetField = (settings: Object, key: string, configuration?: Object): boolean => {
  if (settings.visibleFields && settings.visibleFields.includes(key)) return true;
  const marketConfigsHiddenFields: Array<String> = getConfigurationMarketProperty(
    configuration || {}, settings.market, TemplateMarketPropertyKeys.GEN_HIDDEN_FIELDS
  ) || [];
  return !(settings.hiddenFields && settings.hiddenFields.includes(key)) && !marketConfigsHiddenFields.includes(key);
};

export const concatFieldValues = (fieldsList: Array<string>, widgetState: $BaseWidgetState): string => {
  let concatFieldValue = '';
  let concatenatedFields = 0;
  for (let i = 0; i < fieldsList.length; i++) {
    const field = getWidgetFieldByKey(widgetState.widgetFields, fieldsList[i]);
    if (field) {
      const fieldValue = showWidgetField(widgetState.settings, field.fkey) ?
        getWidgetFieldValue(field, widgetState) : null;

      if (fieldValue) {
        concatFieldValue = concatenatedFields === 0 ?
          concatFieldValue.concat(fieldValue) : concatFieldValue.concat(' ', fieldValue);
        concatenatedFields++;
      }
    }
  }
  return concatFieldValue;
};

export function getWidgetLinkSpanValue(field: $WidgetField, market: string, fieldValue?: ?string) {
  if (!fieldValue) return
  if (field.hasConvertableCountryNumber)
    return getLocalPhoneNumber(fieldValue, market)
  return fieldValue
}

export function getLocalPhoneNumber(phoneNumber?: string, market: string) {
  const marketLocalNumberData = Globals.LOCAL_PHONE_NUMBER_BY_MARKET[market]
  if(!marketLocalNumberData || !phoneNumber) return phoneNumber
  return phoneNumber.replace(marketLocalNumberData.localNumber, marketLocalNumberData.localNumberReplacement)
}
